import { Check, BookOpen } from "lucide-react";
import { MEDIA, CHECKOUT_URL } from "@/lib/constants";

const ebookFeatures = [
    "Plano prático de 30 dias, dia a dia",
    "Os 4 pilares do Método dos Poliglotas",
    "Como destravar Speaking, Listening, Vocabulário e Gramática",
    "Ferramentas certas (Anki, Language Reactor, ESL Pod) explicadas",
    "Mais de 80 páginas, leitura leve e aplicável",
    "Acesso vitalício em PDF, leia no celular, tablet ou computador",
];

export default function Included() {
    return (
        <section
            id="included"
            data-testid="section-included"
            className="bg-cream py-24 lg:py-32"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
                <div className="text-center max-w-3xl mx-auto reveal">
                    <div className="flex items-center justify-center gap-3 mb-5">
                        <span className="hairline w-10" />
                        <span className="label-eyebrow">O que você recebe</span>
                        <span className="hairline w-10" />
                    </div>
                    <h2 className="font-serif text-emerald-brand text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight">
                        O método completo para{" "}
                        <span className="italic text-gold-brand">
                            destravar de verdade
                        </span>
                        .
                    </h2>
                </div>

                {/* Main e-book */}
                <div className="mt-16 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center reveal">
                    <div className="lg:col-span-5 flex justify-center">
                        <img
                            src={MEDIA.ebookMockup}
                            alt="E-book Inglês Destravado em 30 Dias"
                            className="w-full max-w-sm ebook-float rounded-2xl shadow-2xl ring-1 ring-black/10"
                        />
                    </div>
                    <div className="lg:col-span-7">
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-emerald-brand text-gold-brand text-xs uppercase tracking-[0.2em] font-bold mb-5">
                            <BookOpen className="w-3.5 h-3.5" />
                            E-book Oficial
                        </div>
                        <h3 className="font-serif text-emerald-brand text-3xl sm:text-4xl leading-tight">
                            Inglês Destravado em 30 Dias
                        </h3>
                        <p className="mt-3 text-emerald-light/85 text-lg leading-relaxed">
                            O guia completo do método. Linguagem direta, sem
                            enrolação, com cada etapa pensada para um brasileiro
                            que já estudou e quer finalmente <em>falar</em>.
                        </p>
                        <ul className="mt-6 space-y-3">
                            {ebookFeatures.map((f, i) => (
                                <li
                                    key={i}
                                    className="flex gap-3 items-start"
                                    data-testid={`included-feature-${i}`}
                                >
                                    <span className="shrink-0 w-6 h-6 rounded-full bg-gold-brand/15 flex items-center justify-center mt-0.5">
                                        <Check className="w-3.5 h-3.5 text-gold-brand" />
                                    </span>
                                    <span className="text-emerald-brand">
                                        {f}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Value stack */}
                <div className="mt-20 max-w-xl mx-auto bg-white border border-cream rounded-2xl p-7 sm:p-10 text-center reveal">
                    <p className="label-eyebrow">Valor real</p>
                    <p className="mt-3 font-serif text-emerald-brand text-3xl line-through opacity-70">
                        R$ 97
                    </p>
                    <p className="mt-2 font-serif text-emerald-brand text-5xl sm:text-6xl">
                        Hoje por <span className="text-gold-brand">R$ 47</span>
                    </p>
                    <p className="mt-2 text-emerald-light/80">
                        ou 5x de R$ 10,84
                    </p>
                    <a
                        href={CHECKOUT_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-included"
                        className="btn-gold mt-7 w-full"
                    >
                        Quero garantir agora
                    </a>
                </div>
            </div>
        </section>
    );
}
